import { FC, memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { AlertBox, Button } from '@/components';
import { BaseSuccessResponse, amlbotAPI } from '@/api';
import { COMMON_CONTAINER_ID } from '@/config';
import { useApiCall } from '@/hooks';
import { toast } from 'react-toastify';

import styles from './NoticeCandidateEmail.module.sass';

const DELAY = 60 * 1000;

interface NoticeCandidateEmailProps {
  email: string;
  candidate: string;
}

const NoticeCandidateEmail: FC<NoticeCandidateEmailProps> = (props) => {
  const { email, candidate } = props;
  const { t } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (isDisabled) {
      setTimeout(() => {
        setIsDisabled(false);
      }, DELAY);
    }
  }, [isDisabled]);

  const [clickHandler, isLoading, error] = useApiCall(async () => {
    const data: BaseSuccessResponse = await amlbotAPI.resendEmailChange({});

    if (data.success) {
      toast.success(t('translation.confirmation_email_notify_send'), {
        containerId: COMMON_CONTAINER_ID,
      });
    }

    setIsDisabled(true);
  });

  useEffect(() => {
    if (error) {
      toast.error(error, {
        containerId: COMMON_CONTAINER_ID,
      });
    }
  }, [error]);

  return (
    <AlertBox type="warning" className={styles.notice}>
      {{
        description: parse(
          t('translation.email_change_verification_alert', {
            email,
            candidate,
          }),
        ),
        actions: (
          <Button
            size="s"
            type="primary"
            corner="rect"
            onClick={clickHandler}
            disabled={isLoading || isDisabled}
            isLoading={isLoading}
          >
            {t('translation.resend_confirmation_email_btn')}
          </Button>
        ),
      }}
    </AlertBox>
  );
};

export default memo(NoticeCandidateEmail);
